module.exports = __webpack_public_path__ + "img/44.a82761e5.png";